import { render, staticRenderFns } from "./ImageModal.vue?vue&type=template&id=e322b50e&scoped=true&"
import script from "./ImageModal.vue?vue&type=script&lang=ts&"
export * from "./ImageModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e322b50e",
  null
  
)

export default component.exports